import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIsMobile, Modal, Toast, EmailVerifyMessage } from '@repo/common';

import { resendVerifyEmail, cancelVerifyEmail } from '../../api/user/user.api';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();
  const email = location.state?.email || '';
  const returnTo = location.state?.returnTo || '/';
  const isCreator = location.state?.isCreator || false;

  const [isResendSuccessToastVisible, setIsResendSuccessToastVisible] =
    useState(false);
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false);

  const handleLeftButton = () => {
    setIsLogOutModalOpen(false);
  };

  const handleResendEmail = useCallback(async () => {
    try {
      await resendVerifyEmail(email);
      setIsResendSuccessToastVisible(false);
      setTimeout(() => setIsResendSuccessToastVisible(true), 10);
    } catch (error) {
      navigate('/error');
    }
  }, [email, navigate]);

  const handleLogoutAndRetry = () => {
    cancelVerifyEmail(email);
    navigate('/register', { state: { returnTo } });
  };

  const modalButtonSize = isMobile ? 'l' : 'xl';

  return (
    <div>
      <EmailVerifyMessage
        onResend={handleResendEmail}
        onLogout={() => setIsLogOutModalOpen(true)}
        isCreator={isCreator}
      />
      {isResendSuccessToastVisible && (
        <div className='fixed bottom-[28%] left-0 right-0 px-4 z-[1000] flex justify-center'>
          <Toast
            type='success'
            state='solid'
            title='Verification email sent again.'
            hierarchy='important'
            direction='up'
          />
        </div>
      )}
      {isLogOutModalOpen && (
        <Modal
          isOpen
          onClickLeftBtn={handleLeftButton}
          onClickRightBtn={handleLogoutAndRetry}
          title='Leave this page?'
          subText='Your sign-up progress will be lost'
          buttonSize={modalButtonSize}
          leftButtonType='primary'
          leftButtonLabel='Stay'
          leftHideIcon={true}
          rightButtonLabel='Leave'
          rightHideIcon={true}
        />
      )}
    </div>
  );
};

export default VerifyEmailPage;
